//Import for Webpack
import './FeaturedSlideshowImage.scss';

import Module from 'core/ts/system/Module';
import LinkHandler from "core/ts/utils/LinkHandler";

export default class FeaturedSlideshowImage extends Module {
}